import { handleActions } from 'redux-actions'

import {
  requestCities,
  requestCitiesFail,
  requestCitiesSuccess,
  setCitiesDataAction
} from '../actions/cities'

const INITIAL_STATE = {
  loading: false, data: null, error: ''
}

const reducer = handleActions({
  [requestCities]: (state, action) => ({
    error: '',
    loading: true,
    data: null
  }),
  [requestCitiesFail]: (state, action) => ({
    error: `Error - ${action.error}`,
    loading: false,
    data: {}
  }),
  [requestCitiesSuccess]: (state, action) => ({
    error: '',
    loading: false,
    data: action.payload.cities
  }),
  [setCitiesDataAction]: (state, action) => ({
    error: '',
    loading: false,
    data: action.payload
  })
}, INITIAL_STATE)

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/cities.js